import React from 'react';
import { Card } from './ui/card';
import { mockIndustries } from '../utils/mock';
import { Shirt, Laptop, Coffee, Heart, Film, ShoppingBag, Briefcase, Factory } from 'lucide-react';

const iconMap = {
  Shirt: Shirt,
  Laptop: Laptop,
  Coffee: Coffee,
  Heart: Heart,
  Film: Film,
  ShoppingBag: ShoppingBag,
  Briefcase: Briefcase,
  Factory: Factory
};

export const IndustriesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#7C2D12] mb-4">
              Industries We Serve
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We provide trademark registration services to businesses across all industries, protecting brands in diverse markets nationwide.
            </p>
          </div>

          {/* Industries Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {mockIndustries.map((industry, index) => {
              const IconComponent = iconMap[industry.icon];
              
              return (
                <Card 
                  key={index}
                  className="p-6 bg-[#FFF7ED] border-2 border-[#FED7AA] hover:border-[#F97316] transition-all duration-300 hover:shadow-lg text-center group cursor-pointer"
                >
                  <div className="bg-white w-16 h-16 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:bg-[#F97316] transition-colors duration-300">
                    <IconComponent className="text-[#F97316] group-hover:text-white transition-colors duration-300" size={32} />
                  </div>
                  
                  <h3 className="text-lg font-bold text-[#7C2D12] group-hover:text-[#F97316] transition-colors duration-300">
                    {industry.name}
                  </h3>
                </Card>
              );
            })}
          </div>

          {/* Bottom Text */}
          <div className="mt-16 text-center">
            <Card className="p-10 bg-[#FFF7ED] border-2 border-[#FED7AA] max-w-5xl mx-auto">
              <h3 className="text-3xl font-bold text-[#7C2D12] mb-6">
                Your Industry, Our Expertise
              </h3>
              <div className="space-y-4 text-left">
                <p className="text-gray-700 leading-relaxed text-lg">
                  Whether you're launching a fashion brand and need to protect your clothing line and logo, developing innovative software and require protection for your product names and app branding, opening a restaurant or launching a food product line with unique names and packaging, starting a health and wellness company with supplement brands or fitness services, creating entertainment content with show titles and character names, building an e-commerce platform with distinctive branding, offering professional services under a unique business name, or manufacturing products with proprietary brand identities—we have deep experience protecting trademarks across every industry sector.
                </p>
                <p className="text-gray-700 leading-relaxed text-lg">
                  Our trademark experts understand that each industry has unique challenges, competitive landscapes, and naming conventions. We tailor our services to provide the most effective brand protection for your specific market. For fashion brands, we understand the importance of protecting not just names but also design elements, patterns, and color combinations. For technology companies, we know how to navigate the challenges of descriptive software terms and secure protection for innovative product names. For food and beverage businesses, we're experienced in the complex classification issues and the importance of protecting packaging and trade dress alongside traditional word marks.
                </p>
                <p className="text-gray-700 leading-relaxed text-lg">
                  We also understand industry-specific trademark risks. In highly competitive industries like fashion and technology, trademark conflicts are common, requiring strategic searching and careful mark selection. In regulated industries like health and wellness, we help navigate FDA compliance issues that intersect with trademark law. For service-based businesses, we understand the nuances of protecting service marks and ensuring proper specimens of use. Whatever your industry, our experience ensures you receive knowledgeable guidance that accounts for your unique market position, competitive threats, and growth trajectory.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
